<div>
  @for (val of values(); track $index) {
    <div>{{ val }}</div>
  }
</div>
